import { useAtomValue } from 'jotai';
import { PersonJsonLdUtil } from '~/utils/json-ld/person';
import { ProfileJsonLdUtil } from '~/utils/json-ld/profile';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { JsonLdUtil } from '~/utils/json-ld';
import { useSEOLinkBuilder } from '~/utils/build-seo-url';
import { loadable } from 'jotai/utils';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const JsonLD: FC = () => {
  const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));

  const { t } = useTranslation();
  const buildSEOLink = useSEOLinkBuilder();

  if (loadableUser.state !== 'hasData') {
    return null;
  }

  const user = loadableUser.data;

  if (!user) {
    return null;
  }

  return (
    <DynamicHead>
      {JsonLdUtil.buildScriptTag(PersonJsonLdUtil.fromUserDetail({ user, buildSEOLink }))}
      {JsonLdUtil.buildScriptTag(ProfileJsonLdUtil.fromUserDetail({ user, t }))}
    </DynamicHead>
  );
};
